import React, { useState, useEffect } from 'react';
import { ArtistResourcesContainer, Container } from '../../../styles/agency-page-style';
import { BsCashCoin, BsSearch } from 'react-icons/bs';
import { RiMentalHealthLine } from 'react-icons/ri';
import { GiStairsGoal } from 'react-icons/gi';
import { AiOutlineFund } from 'react-icons/ai';
import { MdStackedLineChart } from 'react-icons/md';
import { VscLaw, VscTools } from 'react-icons/vsc';
import { useRouter } from 'next/router';
import { ResourcesSearchProvider } from '../../../contexts/typesense/ResourcesSearchContext';
import { Configure, Hits } from 'react-instantsearch-dom';
import InfiniteHitsResources from '../../../components/resources/infinite-hits-resources';
import DebouncedSearchBoxResource from '../../../components/resources/debounced-search-resource';
import Link from 'next/link';

export default function ArtistResources() {
    const router = useRouter();
    const agencyId = router?.query?.id as string;
    const resources = [
        { title: 'Health & Emergency Resources', icon: <RiMentalHealthLine size={30} color={'#fff'} /> },
        { title: 'Essential & Career Planning', icon: <GiStairsGoal size={30} color={'#fff'} /> },
        { title: 'Legal & Liability', icon: <VscLaw size={30} color={'#fff'} /> },
        { title: 'Marketing & Branding', icon: <MdStackedLineChart size={30} color={'#fff'} /> },
        { title: 'Fundraising & Grants', icon: <AiOutlineFund size={30} color={'#fff'} /> },
        { title: 'Finances & Budgeting', icon: <BsCashCoin size={30} color={'#fff'} /> },
        { title: 'Toolkit ', value: 'Toolkit', icon: <VscTools size={30} color={'#fff'} /> },
    ];

    const [currentSelectedCategory, setCurrentSelectedCategory] = useState("");
    const [searchText, setSearchText] = useState("");
    const [facetFilters, setFacetFilters] = useState<string[]>([]);


    useEffect(() => {
        if (currentSelectedCategory?.length === 0) {
            setFacetFilters(prev => [...prev?.filter(item => !item?.includes("categories"))]);
        } else {
            setFacetFilters(prev => [...prev.filter(pk => !pk?.includes(`categories`)), `categories:${currentSelectedCategory}`])
        }
    }, [currentSelectedCategory])


    return (
        <ResourcesSearchProvider searchScope={"resources"} agencyId={agencyId}>
            <ArtistResourcesContainer>
                <div className='home-banner position-relative'>
                    <div className='search-container col-12 col-lg-8 mx-auto position-absolute text-center'>
                        <h1 className='search-title fw-normal text-white'>
                            Find Artist resource library
                        </h1>
                        <p className='text-white'>
                            The Artist Resource Library features a curated selection of artist business resources including career-focused articles, templates and tool kits, plus videos and virtual conversations featuring Houston area artists and experts.
                            Select a category below and discover tips and tools to support your creative practice.</p>
                        <div className='mt-4 search-input col-10 d-flex flex-column-reverse flex-md-row justify-content-center align-items-center mx-auto'>
                            <div className="position-relative col-12 col-md-12 mb-4 left-input overflow-hidden">
                                <DebouncedSearchBoxResource searchText={searchText} setSearchText={setSearchText} />
                                <div className='d-md-none blue-bg position-absolute p-4 cursor-pointer search-icon'>
                                    <BsSearch size={18} color={'#fff'} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='categories-container'>
                        <ul className='p-0 m-0 categories-list'>
                            {resources?.map((value, index) => (
                                <Link key={`${index}`} href={`/m/resources/r/${value.title}`} passHref>
                                    <li onClick={() => {
                                        if (currentSelectedCategory === value.title)
                                            setCurrentSelectedCategory("");
                                        else
                                            setCurrentSelectedCategory(value.title);
                                    }} className='categories-item'>
                                        <div className='circle-wrapper' style={{ backgroundColor: currentSelectedCategory === value.title ? "#1478dd" : "" }}>
                                            {value.icon}
                                        </div>
                                        <div>
                                            <p className='mt-2 mb-0 text-white categories-title text-center'>{value.title}</p>
                                        </div>
                                    </li></Link>))}
                        </ul>
                    </div>
                </div>
                <Configure hitsPerPage={20} facetFilters={facetFilters} />
                <InfiniteHitsResources searchText={searchText} />

            </ArtistResourcesContainer>
        </ResourcesSearchProvider>
    )
}